// TamaXile — script propio único. Todo vanilla, sin librerías.
document.addEventListener('DOMContentLoaded', function () {
  initReveals();
  initContadores();
  initGaleriaProducto();
  initSelectorVariantes();
  initCarruseles();
});

function initCarruseles() {
  document.querySelectorAll('[data-tx-carrusel]').forEach(function (carrusel) {
    var pista = carrusel.querySelector('[data-tx-carrusel-pista]');
    var prev = carrusel.querySelector('[data-tx-carrusel-prev]');
    var next = carrusel.querySelector('[data-tx-carrusel-next]');
    if (!pista) return;

    function pasoScroll() {
      var tarjeta = pista.querySelector('.tx-tarjeta');
      if (!tarjeta) return pista.clientWidth;
      var estilo = getComputedStyle(pista);
      var gap = parseFloat(estilo.columnGap || estilo.gap) || 0;
      return tarjeta.getBoundingClientRect().width + gap;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        pista.scrollBy(-pasoScroll(), 0);
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        pista.scrollBy(pasoScroll(), 0);
      });
    }
  });
}

function initReveals() {
  var els = document.querySelectorAll('.tx-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('tx-visible'); });
    return;
  }
  var obs = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('tx-visible');
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );
  els.forEach(function (el) { obs.observe(el); });
}

function initContadores() {
  var els = document.querySelectorAll('[data-tx-cifra]');
  if (!els.length || !('IntersectionObserver' in window)) return;
  var obs = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        obs.unobserve(entry.target);
        var el = entry.target;
        var fin = parseFloat(el.getAttribute('data-tx-cifra')) || 0;
        var dur = 1200;
        var inicio = performance.now();
        function paso(ahora) {
          var progreso = Math.min((ahora - inicio) / dur, 1);
          var valor = Math.floor(progreso * fin);
          el.textContent = valor.toLocaleString('es-MX');
          if (progreso < 1) requestAnimationFrame(paso);
          else el.textContent = fin.toLocaleString('es-MX');
        }
        requestAnimationFrame(paso);
      });
    },
    { threshold: 0.4 }
  );
  els.forEach(function (el) { obs.observe(el); });
}

function initGaleriaProducto() {
  var galeria = document.querySelector('[data-tx-galeria]');
  if (!galeria) return;
  var principal = galeria.querySelector('[data-tx-galeria-principal]');
  var miniaturas = galeria.querySelectorAll('[data-tx-galeria-mini]');
  if (!principal || !miniaturas.length) return;
  miniaturas.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var src = mini.getAttribute('data-full');
      var alt = mini.getAttribute('data-alt') || '';
      principal.src = src;
      principal.alt = alt;
      miniaturas.forEach(function (m) { m.classList.remove('tx-mini-activa'); });
      mini.classList.add('tx-mini-activa');
    });
  });
}

function initSelectorVariantes() {
  var forms = document.querySelectorAll('[data-tx-form-producto]');
  forms.forEach(function (form) {
    var dataEl = form.querySelector('[data-tx-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try {
      variantes = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    var selects = form.querySelectorAll('[data-tx-opcion]');
    var inputId = form.querySelector('[data-tx-variant-id]');
    var precioEl = form.querySelector('[data-tx-precio]');
    var compareEl = form.querySelector('[data-tx-precio-comparado]');
    var boton = form.querySelector('[data-tx-boton-comprar]');

    function variantePorOpciones() {
      var valores = [];
      selects.forEach(function (s) { valores.push(s.value); });
      return variantes.find(function (v) {
        return v.options.every(function (opt, i) { return opt === valores[i]; });
      });
    }

    function actualizar() {
      var v = variantePorOpciones();
      if (!v) return;
      if (inputId) inputId.value = v.id;
      if (precioEl) precioEl.textContent = formatoMoneda(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = formatoMoneda(v.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (boton) {
        boton.disabled = !v.available;
        boton.textContent = v.available
          ? boton.getAttribute('data-texto-disponible')
          : boton.getAttribute('data-texto-agotado');
      }
    }

    function formatoMoneda(centavos) {
      return '$ ' + (centavos / 100).toLocaleString('es-MX', { minimumFractionDigits: 2 });
    }

    selects.forEach(function (s) { s.addEventListener('change', actualizar); });
    actualizar();
  });
}
